<template>
  <div id="app">
    <router-view v-if="isRouterAlive"  :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',

  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide() {
    return {
      reload: this.reload
    };
  },

  created() {
  },

  methods: {

    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
}
</script>

<style>
@import url('./assets/css/elementui.css');
@import url('./assets/css/common.css');
@import url('./assets/css/variable.css');
@import url('./assets/css/flex.css');
</style>



// WEBPACK FOOTER //
// src/App.vue